import { createTheme } from "@mui/material/styles";

/**
 * Shared MUI theme for CommonSpace: palette, typography, spacing, and
 * component defaults used across Landing, Commonplace, Knowledge Lists, and Header.
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: "#0d7377",
      light: "#14a3a8",
      dark: "#095456",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#2e7d32",
      light: "#60ad5e",
      dark: "#005005",
      contrastText: "#fff",
    },
    background: {
      default: "#f5f5f0",
      paper: "#ffffff",
    },
    divider: "#e0e0e0",
    text: {
      primary: "#1a1a1a",
      secondary: "#5f6368",
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h2: {
      fontSize: "2.25rem",
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    h6: {
      fontSize: "1.125rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.43,
    },
    hero: {
      fontSize: "2rem",
      fontWeight: 600,
      lineHeight: 1.2,
    },
    subtitle: {
      fontSize: "1.125rem",
      lineHeight: 1.4,
      color: "text.secondary",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false,
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 1,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});
